module.exports = "p {\n  font-family: Lato; }\n"